module.exports = __webpack_public_path__ + "static/commonground-s-4e71782303a39339a6e053eeacbcdd09.jpg";